import React from 'react';
import Skeleton from '../shared/ui/Skeleton';

const PackageSkeleton = ({ view = 'grid' }) => {
  if (view === 'list') {
    return (
      <div className="flex min-w-0 flex-col gap-4 rounded-3xl border border-slate-200 bg-white p-4 sm:flex-row">
        <Skeleton className="h-48 w-full sm:h-40 sm:w-1/3" />
        <div className="flex min-w-0 flex-1 flex-col gap-3">
          <Skeleton className="h-4 w-1/3" />
          <Skeleton className="h-6 w-2/3" />
          <Skeleton className="h-4 w-1/2" />
          <Skeleton className="h-10 w-full" />
        </div>
      </div>
    );
  }
  return (
    <div className="rounded-3xl border border-slate-200 bg-white p-4">
      <Skeleton className="h-48 w-full" />
      <div className="mt-4 space-y-3">
        <Skeleton className="h-4 w-1/3" />
        <Skeleton className="h-6 w-2/3" />
        <Skeleton className="h-4 w-1/2" />
      </div>
    </div>
  );
};

export default PackageSkeleton;
